import React, { useState, useEffect } from 'react';
import { toInteger } from 'lodash';
import numeral from 'numeral';



import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { IoIosCalculator } from "react-icons/io";

import Page from 'src/components/Page';
import agm from '../../services/agm';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Budget from './Budget';
import Create from './Create';
import Treatment from './Treatment';



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: -1,
  numero: '',
  ocorrencia: '',
  ccusto: '',
  unidade: '',
  idOcorrencia: null,
  abertura: null,
  dataCriacao: new Date(),
  dataEnvio: null,
  tipoOcorrencia: '',
  categoria: '',
  foiExecutado: 0,
  valorMaoObra: 0.0,
  valorMaterial: 0.0,
  valorDesconto: 0.0,
  total: 0.0,
  FASE_ORCAMENTO: 1,
  ORCAMENTISTA: null,
  TECNICO: null,
  idProduto: '',
  qtdProduto: '',
  codigoProduto: '',
  nomeProduto: '',
  lpuProduto: '',
  custoProduto: '',
  bdiProduto: '',
  valorProduto: '',
  aplicacaoProduto: '',
  unidadeProduto: '',
  origemProduto: '',
  instalacaoProduto: '',
  produto: null,
  atualizarPdf: false,
  chavePdf: null,
  servicoExecutar: null
}

const defaultDependencies = {
  loaded: false,
  items: [],
  removes: [],
  phases: [],
  makers: [],
  technicians: [],
  applications: [],
  units: [],
  origins: [],
  region: null
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const FATURAR = 6;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Ocorrência', field: 'item.ocorrencia.numero', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Centro Custo', field: 'formatNumber(item.ocorrencia.unidade.codigo,"0000")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Unidade', field: 'item.ocorrencia.unidade.nome', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Status Cliente', field: '(item.ocorrencia.statusEmpresa) ? item.ocorrencia.statusEmpresa.nome : "Não Informado"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Lote', field: '(item.ocorrencia.lote) ? formatNumber(item.ocorrencia.lote.codigo, "000000") : "-"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Número', field: 'formatNumber(item.numero, "000000")', size: -1, sortable: 'numero', exportable: 1, wrap: 0 },
  { name: 'Data Orçamento', field: 'formatDate(item.dataCriacao)', size: -1, sortable: 'dataCriacao', exportable: 1, wrap: 0 },
  { name: 'Valor Mão Obra', field: 'formatDecimal(item.valorMaoObra)', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Material', field: 'formatDecimal(item.valorMaterial)', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Total', field: 'formatDecimal((parseFloat(item.valorMaterial) + parseFloat(item.valorMaoObra)) - parseFloat(item.valorDesconto))', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Fase Orçamento', field: 'item.fase.nome', size: -1, sortable: 0, exportable: 1, wrap: 0 }
];

const defaultEmptyMessage = "Nenhum Orçamento Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Em Orçamento - Número da Ocorrência', refine: 1, label: 'Número da Ocorrência', history: 0 },
  { id: 2, name: 'Aguardando Aprovação - Número da Ocorrência', refine: 2, label: 'Número da Ocorrência', history: 0 },
  { id: 3, name: 'Orçamento Aprovado - Número da Ocorrência', refine: 3, label: 'Número da Ocorrência', history: 0 },
  { id: 4, name: 'Todos - Número da Ocorrência', refine: 4, label: 'Número da Ocorrência', history: 0 },
  { id: 5, name: 'Histórico - Fase do Orçamento', refine: 5, label: 'Fase do Orçamento nas datas', history: 1 },
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const defaultStatusRegister = {
  id: null,
  orcamento: null,
  usuario: null,
  justificativa: '',
  data: null,
  status: null,
  lote: null,
  ocorrencia: null
}

const defaultStatusHistory = {
  registros: [],
  acoes: [],
  lotes: []
}

const Budgets = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
  const [statusHistory, setStatusHistory] = useState(defaultStatusHistory);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {
    await agm.post('/orcamentos/export', {
      format: format,
      filtro: filter,
      colunas: defaultResultColumns
    }, {}).then(async (response) => {
      setMessage(response.data);
      setOpenAlert(true);
      const link = window.document.createElement('a');
      var url = process.env.REACT_APP_AGM_ENDPPOINT + '/exports/orcamentos.xlsx';
      link.setAttribute('download', 'orcamentos.xlsx');
      link.href = url;
      window.document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  }

  const openEdition = (item) => {
    setItem(item);
    agm.get('/orcamentos/dependencias/' + item.id + "," + item.ocorrencia.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          phases: response.data.fases,
          makers: response.data.orcamentistas,
          technicians: response.data.tecnicos,
          items: response.data.itens,
          removes: [],
          applications: response.data.aplicacoes,
          units: response.data.unidades,
          origins: response.data.origens,
          region: response.data.regiao
        });
        item.codigo = item.ocorrencia.numero;
        item.total = (item.valorMaoObra + item.valorMaterial) - item.valorDesconto;
        item.idProduto = '';
        item.qtdProduto = '';
        item.codigoProduto = '';
        item.nomeProduto = '';
        item.lpuProduto = '';
        item.custoProduto = '';
        item.bdiProduto = '';
        item.valorProduto = '';
        item.aplicacaoProduto = '';
        item.unidadeProduto = '';
        item.origemProduto = '';
        item.instalacaoProduto = '';
        item.produto = null;
        item.atualizarPdf = false;
        setItem(item);
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openCreation = (item) => {
    setItem(item);
    agm.get('/orcamentos/dependencias/' + item.id + "," + item.ocorrencia.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          phases: response.data.fases,
          makers: response.data.orcamentistas,
          technicians: response.data.tecnicos,
          items: response.data.itens,
          removes: [],
          applications: response.data.aplicacoes,
          units: response.data.unidades,
          origins: response.data.origens,
          region: response.data.regiao
        });
        item.numero = response.data.proximoOrcamento.valor;
        item.idOcorrencia = '';
        item.ccusto = null;
        item.unidade = null;
        item.abertura = null;
        item.tipoOcorrencia = null;
        item.categoria = null;
        item.valorMaoObra = 0.0;
        item.valorMaterial = 0.0;
        item.valorDesconto = 0.0;
        item.idProduto = '';
        item.qtdProduto = '';
        item.codigoProduto = '';
        item.nomeProduto = '';
        item.lpuProduto = '';
        item.custoProduto = '';
        item.bdiProduto = '';
        item.valorProduto = '';
        item.instalacaoProduto = '';
        item.aplicacaoProduto = '';
        item.unidadeProduto = '';
        item.origemProduto = '';
        item.produto = null;
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const updateDependencies = (item) => {
    setItem(item);
    agm.get('/orcamentos/dependencias/' + item.id + "," + item.idOcorrencia, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          phases: response.data.fases,
          makers: response.data.orcamentistas,
          technicians: response.data.tecnicos,
          items: response.data.itens,
          removes: [],
          applications: response.data.aplicacoes,
          units: response.data.unidades,
          origins: response.data.origens,
          region: response.data.regiao
        });
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Orçamento',
      message: 'Deseja excluir o orçamento selecionado?',
      warn: 'Esta ação irá remover todos os produtos e os registros do andamento do processo do orçamento ' + numeral(item.numero).format('000000') +
        '. Os dados não poderão mais ser recuperados.'
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = async (item) => {
    setItem(item);
    agm.post('/orcamentos/tratamento', { orcamento: item }, {}).then((response) => {
      if (!response.data.error) {
        setStatusHistory(response.data)
        setOpenTreatmentDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const updateTreatmentValues = async (values, statusHistory) => {
    values.orcamento = item.id;
    values.usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    values.data = new Date();
    values.envio = item.dataEnvio;
    values.ocorrencia = item.ocorrencia.id;
    if (!values.justificativa) {
      var fase = '';
      var acoes = statusHistory.acoes;
      for (let index = 0; index < acoes.length; index++) {
        const element = acoes[index];
        if (element.id == values.status) {
          fase = element.nome;
          break;
        }
      }
      values.justificativa = 'Fase alterada manualmente pelo usuário para ' + fase;
      if (values.lote && values.status == FATURAR) {
        var lote = '';
        var lotes = statusHistory.lotes;
        for (let index = 0; index < lotes.length; index++) {
          const element = lotes[index];
          if (element.id == values.lote) {
            lote = numeral(element.codigo).format('000000');
            values.justificativa = 'Fase alterada manualmente pelo usuário para ' + fase + '. Orçamento foi inserido no lote ' + lote;
            break;
          }
        }
      }
    }
    agm.put('/orcamentos/tratamento/' + item.id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeTreatment();
      }
      values.justificativa = '';
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  }

  const updateValues = (values, items, removes) => {
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    agm.put('/orcamentos/' + values.id, { orcamento: values, itens: items, removes: removes, usuario: usuario }).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values, items) => {
    agm.post('/orcamentos', { orcamento: values, itens: items }).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const deleteValues = (values) => {
    agm.delete('/orcamentos/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    filter.profile = localStorage.getItem('profile');
    agm.post('/orcamentos/historico', { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
      profile: localStorage.getItem('profile')
    };
    setFilter(value);
    agm.post('/orcamentos/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (vision, keyword, page, rows, startDateTime, endDateTime) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision,
      profile: localStorage.getItem('profile')
    };
    setVision(vision);
    setFilter(value);
    agm.post('/orcamentos/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Ocorrência"
    >

      <Container maxWidth={false}>

        <Toolbar
          icon={IoIosCalculator}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
          dependencies={dependencies}

        />

        <Alerts
          message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations
          item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Treatment
          item={item}
          icon={IoIosCalculator}
          open={openTreatmentDialog}
          closeTreatment={closeTreatment}
          updateTreatmentValues={updateTreatmentValues}
          statusHistory={statusHistory}
          statusRegister={defaultStatusRegister}
        />

        <Budget
          item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          selectedMode={selectedMode}
        />

        <Create
          item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={IoIosCalculator}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                dependencies={dependencies}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

export default Budgets;
